module.exports = __webpack_public_path__ + "static/assets/af9e23d8623a748dd02bd147eb09d99f.svg";